<template>
  <div>
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240);background: #ffffff"
      :title="$t('ORDER_DETAIL')"
      :breadcrumb=" { props: { routes:[{path:'/',breadcrumbName:$t('HOME')}
      ,{path:'/orders',breadcrumbName:$t('ORDER_LIST')}
      ,{path:`/orders/${orderId}`,breadcrumbName:$t('ORDER_DETAIL')}
      ] } }"
    />
    <div
      style="position: relative;
          line-height: 46px;
          height: 46px;
          background: #ffffff;
          white-space: nowrap;
          border: 0;
          border-bottom: 1px solid #e8e8e8;
          -webkit-box-shadow: none;
          box-shadow: none;">
      <a-space style="padding-left: 20px;font-weight: 700">
        #{{ form.data.orderNo }}
        <a-tag color="pink" v-if="form.data.status === 'UN_PAID'">
          {{ $t('UN_PAID') }}
        </a-tag>
        <a-tag color="red" v-if="form.data.status === 'UN_SHIPPED'">
          {{ $t('UN_SHIPPED') }}
        </a-tag>
        <a-tag color="orange" v-if="form.data.status === 'TO_BE_SHIPPED'">
          {{ $t('TO_BE_SHIPPED') }}
        </a-tag>
        <a-tag color="green" v-if="form.data.status === 'TRANSACTION_COMPLETED'">
          {{ $t('TRANSACTION_COMPLETED') }}
        </a-tag>
        <a-tag color="cyan" v-if="form.data.status === 'APPLY_REFUND'">
          {{ $t('APPLY_REFUND') }}
        </a-tag>
        <a-tag color="blue" v-if="form.data.status === 'REFUND'">
          {{ $t('REFUND') }}
        </a-tag>
        <a-tag color="purple" v-if="form.data.status === 'REFUND_COMPLETED'">
          {{ $t('REFUND_COMPLETED') }}
        </a-tag>
        <a-tag color="#6f6f6f" v-if="form.data.status === 'CANCEL'">
          {{ $t('CANCEL') }}
        </a-tag>
      </a-space>
      <a-space style="position: absolute;right: 8px;">
        <a-button-group>
          <a-button :disabled="!prevId" @click="()=>{$router.push(`/website-order/${prevId}/detail`)}">
            <a-icon type="left"/>
          </a-button>
          <a-button :disabled="!nextId" @click="()=>{$router.push(`/website-order/${nextId}/detail`)}">
            <a-icon type="right"/>
          </a-button>
        </a-button-group>
        <!--        <a-button type="danger" @click="()=>{refundForm.visible = true}" v-if="form.data.status === 'UN_SHIPPED' || form.data.status === 'TRANSACTION_COMPLETED' ">退款-->
        <!--        </a-button>-->
        <a-button @click="()=>{$router.go(-1)}">
          {{ $t('BACK') || '返回' }}
        </a-button>
      </a-space>
    </div>
    <div style="padding: 16px">
      <a-row :gutter="24">
        <a-col span="24"></a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="16">
          <a-card
            title="订单">
            <a-descriptions
              :column="5"
              :title="detail.name"
              :key="detail.id"
              v-for="detail in form.data.orderDetails"
              bordered>
              <a-descriptions-item label="商品">
                <a-avatar :src="detail.image"/>
              </a-descriptions-item>
              <a-descriptions-item label="描述">
                {{ detail.name }}
                <a-divider type="vertical"/>
                {{ detail.specs }}
              </a-descriptions-item>
              <!--              <a-descriptions-item label="编号">-->
              <!--                {{ detail.goodsSKU.code }}-->
              <!--              </a-descriptions-item>-->
              <a-descriptions-item label="数量">
                ×{{ detail.quantity }}
              </a-descriptions-item>
              <a-descriptions-item label="金额">
                {{ detail.unit }} {{ detail.otherAmount }}
              </a-descriptions-item>
            </a-descriptions>
          </a-card>
          <a-card style="margin-top: 16px" title="付款信息">
            <a-descriptions bordered>
              <a-descriptions-item label="商品总计(人民币)">
                ¥ {{ form.data.amount }}
              </a-descriptions-item>
              <a-descriptions-item label="运费(人民币)">
                ¥ {{ form.data.postageCNY }}
              </a-descriptions-item>
              <a-descriptions-item label="保险费用(人民币)">
                ¥ {{ form.data.insuranceCNY }}
              </a-descriptions-item>
              <a-descriptions-item label="总结算金额(人民币)">
                ¥ {{ form.data.totalAmount }}
              </a-descriptions-item>
              <a-descriptions-item label="商品总计">
                {{ form.data.unit }} {{ form.data.otherAmount }}
              </a-descriptions-item>
              <a-descriptions-item label="运费">
                {{ form.data.unit }} {{ form.data.postage }}
              </a-descriptions-item>
              <a-descriptions-item label="保险费用">
                {{ form.data.unit }} {{ form.data.insurance }}
              </a-descriptions-item>
              <a-descriptions-item label="总结算金额">
                {{ form.data.unit }} {{ form.data.totalOtherAmount }}
              </a-descriptions-item>
              <!--              <a-descriptions-item label="Redsys费用">-->
              <!--                {{ form.data.unit }} {{ form.data.insurance }}-->
              <!--              </a-descriptions-item>-->
              <a-descriptions-item label="结算货币">
                {{ form.data.unit }}
              </a-descriptions-item>
            </a-descriptions>
          </a-card>
          <a-card style="margin-top: 16px" title="订单状态变化">
            <order-status-change-website
              :goodsOrderId="orderId"/>
          </a-card>
          <a-card style="margin-top: 16px" title="物流信息">
            <a-descriptions bordered>
              <a-descriptions-item label="货运单号" bordered>
                <span style="padding-right: 20px" v-if="table.nu">#{{ table.nu }}  </span>
                <span style="padding-right: 20px" v-else> -</span>
              </a-descriptions-item>
              <a-descriptions-item label="目前状态">
                <span style="padding-right: 20px" v-if="table.state"> {{ expressState[table.state] }} </span>
                <span style="padding-right: 20px" v-else> 未发货</span>
                <a-button v-if="table.state" type="link" @click="getOrderExpressTrack">获取详情</a-button>
              </a-descriptions-item>
            </a-descriptions>
          </a-card>
          <a-card v-if="refundTable.data.length" style="margin-top: 16px" title="退款信息">
            <div :key="order.id" v-for="order in refundTable.data">
              <div> {{ order.createAt }}
                <a-divider type="vertical"/>
                {{ order.cause }}
              </div>
              <a-descriptions
                :column="5"
                :key="item.id"
                v-for="item in order.goodsOrderRefundDetails"
                :title="`${item.goodsSKU.name }`">
                <a-descriptions-item label="">
                  <a-avatar :src="item.goodsSKU.image"/>
                </a-descriptions-item>
                <a-descriptions-item label="">
                  {{ item.goodsSKU.name }}
                  <a-divider type="vertical"/>
                  {{ item.goodsSKU.specs }}
                </a-descriptions-item>
                <a-descriptions-item label="编号">
                  {{ item.goodsSKU.code }}
                </a-descriptions-item>
                <a-descriptions-item label="数量">
                  <span style="color: red">-{{ item.quantity }}</span>
                </a-descriptions-item>
                <a-descriptions-item label="金额">
                  <span style="color: red">-{{ item.refundAmount }}</span>
                </a-descriptions-item>
              </a-descriptions>
            </div>
          </a-card>
        </a-col>
        <a-col :span="8">
          <a-card title="客户信息">
            <!--            <a slot="extra" @click="editDeliverInfo" href="javascript:void(0)">修改发货信息</a>-->
            <div>
              <a-descriptions title="发货信息" :column="1">
                <a-descriptions-item label="firstName">
                  {{ form.data.firstName }}
                </a-descriptions-item>
                <a-descriptions-item label="lastName">
                  {{ form.data.lastName }}
                </a-descriptions-item>
                <a-descriptions-item label="phone">
                  {{ form.data.phonePrefix }} {{ form.data.phone }}
                </a-descriptions-item>
                <a-descriptions-item label="email">
                  {{ form.data.email }}
                </a-descriptions-item>
                <a-descriptions-item label="country">
                  {{ form.data.country }}
                </a-descriptions-item>
                <a-descriptions-item label="town">
                  {{ form.data.town }}
                </a-descriptions-item>
                <a-descriptions-item label="street">
                  {{ form.data.street }}
                </a-descriptions-item>
                <a-descriptions-item label="post code">
                  {{ form.data.postCode }}
                </a-descriptions-item>
              </a-descriptions>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </div>
    <a-modal
      title="退款"
      @ok="confirmRefund"
      v-model="refundForm.visible"
      :width="1200"
      :confirmLoading="refundForm.loading">
      <a-form-model ref="refundForm" :rules="refundForm.rules" :model="refundForm.data">
        <a-table rowKey="goodsSKU.id" :pagination="false" :data-source="refundForm.data.details">
          <a-table-column>
            <template slot-scope="text, record">
              <a-checkbox v-model="record.isChecked">
              </a-checkbox>
            </template>
          </a-table-column>
          <a-table-column>
            <template slot-scope="text, record">
              <a-avatar :src="record.goodsSKU.image"/>
            </template>
          </a-table-column>
          <a-table-column
            title="商品">
            <template slot-scope="text, record">
              {{ record.goodsSKU.name }}/{{ record.goodsSKU.specs }}
            </template>
          </a-table-column>
          <a-table-column
            title="商品详情">
            <template slot-scope="text, record">
              {{ record.currentUnitPrice }} ×{{ record.quantity }}
            </template>
          </a-table-column>
          <a-table-column
            title="订单金额">
            <template slot-scope="text, record">
              {{ record.amount }}
            </template>
          </a-table-column>
          <a-table-column
            title="退款数量">
            <template slot-scope="text, record">
              {{ record.refundQuantity }}
            </template>
          </a-table-column>
          <!-- <a-table-column
            title="退款金额">
            <template slot-scope="text, record">
              <a-input-number
                v-model="record.refundAmount"
                :step="1"
                :min="0"
                :max="record.limitAmount"></a-input-number>
            </template>
          </a-table-column> -->
        </a-table>
        <a-form-model-item label="退款原因" prop="cause">
          <a-input v-model="refundForm.data.cause"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal
      v-model="orderExpressForm.visible"
      title="订单物流详情"
      :footer="null">
      <website-order-express-track
        class="express-form"
        :goodsOrderExpressId="orderExpressId"
        :goods-order-track-data="table.data"/>
    </a-modal>

  </div>
</template>

<script>
import {
  _queryOrder,
  _queryOrderPosition,
  _queryRefundOrders,
  _refundOrderDetail,
  _updateOrderDeliverInfo,
} from '@/api/websiteOrderApi';
import { _queryWebsiteOrderExpressTrack } from '@/api/websiteOrderExpressApi';
import OrderStatusChangeWebsite from '@/components/OrderStatusChangeWebsite.vue';
import WebsiteOrderExpressTrack from '@/views/website/orderExpress/WebsiteOrderExpressTrack.vue';

async function getOrder() {
  const result = await _queryOrder(this.orderId);
  if (result) {
    this.form.data = result;
  }
  const refundOrders = await _queryRefundOrders(this.orderId);
  this.refundTable.data = refundOrders;
  const positionResult = await _queryOrderPosition(this.orderId);
  this.nextId = positionResult.next;
  this.prevId = positionResult.prev;
  this.getOrderExpressList();
  const refundAmountByDetailId = new Map();
  const refundQuantityByDetailId = new Map();
  refundOrders.forEach((item) => {
    item.goodsOrderRefundDetails.forEach((x) => {
      if (!refundAmountByDetailId.has(x.orderDetailId)) {
        refundAmountByDetailId.set(x.orderDetailId, 0);
      }
      refundAmountByDetailId.set(x.orderDetailId, refundAmountByDetailId.get(x.orderDetailId) + x.refundAmount);
      if (!refundQuantityByDetailId.has(x.orderDetailId)) {
        refundQuantityByDetailId.set(x.orderDetailId, 0);
      }
      refundQuantityByDetailId.set(x.orderDetailId, refundQuantityByDetailId.get(x.orderDetailId) + x.quantity);
    });
  });

  this.refundForm.data.details = result.goodsOrderDetails.map(x => ({
    isChecked: false,
    detailId: x.id,
    goodsSKU: x.goodsSKU,
    currentUnitPrice: x.currentUnitPrice,
    amount: x.amount,
    refundAmount: x.amount,
    limitAmount: x.amount - (refundAmountByDetailId.get(x.id) || 0),
    quantity: x.quantity,
    limitQuantity: x.quantity - (refundQuantityByDetailId.get(x.id) || 0),
    refundQuantity: x.quantity,
    refundType: 'RETURN_REFUND',
  }));
}

function getOrderExpressTrack() {
  this.orderExpressId = this.table.nu;
  this.orderExpressForm.visible = true;
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

async function getOrderExpressList() {
  this.table = await _queryWebsiteOrderExpressTrack(this.orderId);
}

function editDeliverInfo() {
  this.deliverForm.data.address = this.form.data.address;
  this.deliverForm.data.zipCode = this.form.data.zipCode;
  this.deliverForm.data.province = this.form.data.province;
  this.deliverForm.data.district = this.form.data.district;
  this.deliverForm.data.city = this.form.data.city;
  this.deliverForm.data.phone = this.form.data.phone;
  this.deliverForm.data.name = this.form.data.name;
  this.deliverForm.visible = true;
}

async function saveDeliverInfo() {
  const result = await _updateOrderDeliverInfo(this.orderId, {
    address: this.deliverForm.data.address,
    zipCode: this.deliverForm.data.zipCode,
    province: this.deliverForm.data.province,
    city: this.deliverForm.data.city,
    phone: this.deliverForm.data.phone,
    district: this.deliverForm.data.district,
    name: this.deliverForm.data.name,
  });
  if (result) {
    this.deliverForm.visible = false;
    this.$message.success(this.$t('UPDATE_SUCCESS'));
    this.getOrder();
  }
}

function confirmRefund() {
  this.refundForm.loading = true;

  const refundItems = this.refundForm.data.details.filter(x => x.isChecked && x.refundQuantity > 0);

  this.$refs.refundForm.validate(async (valid) => {
    if (refundItems.length > 0 && valid) {
      const refundDetails = refundItems.map(x => ({
        refundAmount: x.refundAmount,
        refundQuantity: x.refundQuantity,
        detailId: x.detailId,
        skuId: x.goodsSKU.id,
      }));
      const result = await _refundOrderDetail(this.orderId, {
        cause: this.refundForm.data.cause,
        details: refundDetails,
      });
      if (result) {
        this.$message.success('退款成功!');
        this.refundForm.visible = false;
        this.refundForm.loading = false;
        if (this.orderId) {
          this.getOrder();
        }
      }
    }
  });
}

export default {
  components: {
    WebsiteOrderExpressTrack,
    OrderStatusChangeWebsite
  },
  name: 'WebsiteOrderDetail',
  props: {
    orderId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    orderId() {
      if (this.orderId) {
        this.getOrder();
      }
    },
  },
  methods: {
    onCancel,
    getOrder,
    getOrderExpressList,
    confirmRefund,
    editDeliverInfo,
    saveDeliverInfo,
    getOrderExpressTrack,
  },
  data() {
    return {
      expressState: {
        0: '在途',
        1: '揽收',
        2: '疑难',
        3: '在途',
        4: '退签',
        5: '派件',
        8: '清关',
        14: '拒签',
      },
      orderExpressForm: {
        visible: false,
      },
      orderExpressId: '',
      prevId: '',
      nextId: '',
      table: {
        message: null,
        state: 0,
        status: null,
        condition: null,
        ischeck: null,
        com: '',
        nu: '',
        data: [],
      },
      refundTable: {
        data: [],
      },
      deliverForm: {
        visible: false,
        data: {
          city: '',
          name: '',
          district: '',
          address: '',
          province: '',
          zipCode: '',
          phone: '',
        },
      },
      refundForm: {
        visible: false,
        loading: false,
        data: {
          cause: '',
          details: [],
        },
        rules: {
          cause: [{ required: true }],
        },
      },
      form: {
        data: {
          id: '',
          isDeleted: 0,
          createAt: '',
          updateAt: '',
          transactionId: null,
          channel: '',
          payment: null,
          orderNo: '',
          image: null,
          amount: 0,
          otherAmount: 0,
          userId: '',
          status: 'TO_BE_SHIPPED',
          paySign: null,
          prePayId: null,
          email: '',
          country: '',
          town: '',
          phone: '',
          phonePrefix: '',
          street: '',
          firstName: '',
          lastName: '',
          postCode: '',
          aging: 2,
          postage: 0,
          postageCNY: 0,
          insurance: 0,
          insuranceCNY: 0,
          totalAmount: 0,
          totalOtherAmount: 0,
          totalQuantity: 1,
          nonceStr: null,
          signType: null,
          timeStamp: null,
          outTradeNo: null,
          outRefundNo: null,
          remark: null,
          user: {
            id: '',
            isDeleted: 0,
            createAt: '',
            updateAt: '',
            email: '',
            gender: '',
            birthday: '',
            phone: '',
            firstName: '',
            lastName: '',
            phonePrefix: '',
            validCode: null
          },
          orderDetails: [
            {
              id: '',
              isDeleted: 0,
              createAt: '',
              updateAt: '',
              userId: '',
              skuId: '',
              orderId: '',
              goodsId: '',
              name: '',
              size: '',
              material: '',
              image: '',
              quantity: 1,
              status: 'UN_PAID',
              amount: 0,
              otherAmount: 0,
              goodsSKU: null
            }
          ],
          location: null,
          unit: null
        },
        title: '',
      },
    };
  },
  created() {
    if (this.orderId) {
      this.getOrder();
    }
  },
};
</script>

<style scoped>
.express-form {
  width: 100%;
  height: 450px;
  overflow-y: auto;
  overflow-x: auto;
}
</style>
